import './App.css';
import React from 'react';
import ProductGuide from './components/product-guide/index';
import ProductDetail from './components/product-guide/product_detail';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

// 首页
import IndexPage from './components/wx/home';

// 官网产品目录
import Catalog from './components/wx/catalog/home';
import WaterIndex from './components/wx/catalog/watermeter/index';
import WaterS663 from './components/wx/catalog/watermeter/s663';
import WaterMec from './components/wx/catalog/watermeter/mec';
import WaterVoha from './components/wx/catalog/watermeter/voha';
import WaterPara from './components/wx/catalog/watermeter/para';
import ElecIndex from './components/wx/catalog/electricmeter/index';
import ElecDds5168b from './components/wx/catalog/electricmeter/dds5168b';
import ElecDdsu5168 from './components/wx/catalog/electricmeter/ddsu5168';
import ElecDds5168_4p from './components/wx/catalog/electricmeter/dds5168_4p';
import ElecDtsd5168 from './components/wx/catalog/electricmeter/dtsd5168';
import ElecPara from './components/wx/catalog/electricmeter/para';
import HeatIndex from './components/wx/catalog/heatmeter/index';
import HeatR200 from './components/wx/catalog/heatmeter/r200';
import HeatH100 from './components/wx/catalog/heatmeter/h100';
import GatewayIndex from './components/wx/catalog/gateway/index';
import GatewayGw200 from './components/wx/catalog/gateway/gw200';
import GatewayJoytcp from './components/wx/catalog/gateway/joytcp';
import GatewayCV151 from './components/wx/catalog/gateway/cv151';
import GatewayCT213 from './components/wx/catalog/gateway/ct213';

// 软件方案
import Software from './components/wx/solution/software';

// 解决方案
import Solution from './components/wx/solution/home';
import SolutionWater from './components/wx/solution/water';
import SolutionHeat from './components/wx/solution/heat';
import SolutionElec from './components/wx/solution/elec';

// App 隐私
import PrivacyMendao from './components/app/privacy/mendao';
import PrivacyAms from './components/app/privacy/ams';
import PrivacyAmr from './components/app/privacy/amr';

// 招聘
import JobList from './components/app/job/list';
import JobDetail from './components/app/job/detail';

// 关于
import AboutAmr from './components/app/about/amr';
import AboutMeterReading from './components/app/about/meterreading';
import AboutSettle from './components/app/about/settle';
import AboutDin2p from './components/app/about/din2p';

// 硬件二维码互动页：公开地址不可变
import CT213 from './components/product-interaction/ct213';
import CV151 from './components/product-interaction/cv151';
import GW220 from './components/product-interaction/gw220';
import DDSU5168 from './components/product-interaction/ddsu5168';
import DDSU5168Wiring from './components/product-interaction/ddsu5168/wiring';
import DDSU5168FourPole from './components/product-interaction/ddsu5168-4p';
import DDSU5168FourPoleWiring from './components/product-interaction/ddsu5168-4p/wiring';
import DTSU5168 from './components/product-interaction/dtsu5168';
import DTSU5168Wiring from './components/product-interaction/dtsu5168/wiring';
import ProductInteractionList from './components/product-interaction/list';
import GE400 from './components/product-interaction/ge400';
import GE400Wiring from './components/product-interaction/ge400/wiring';
import JOYS550 from './components/product-interaction/joys550';
import JOYS550Installation from './components/product-interaction/joys550/installation';
import FaqPage from './components/faq';

import Details from './components/manual/details';

const redirectTo = (location, pathname) => ({
  pathname,
  search: location.search,
  hash: location.hash,
  state: location.state
});

const LegacyCatalogRedirect = ({ location }) => (
  <Redirect to={redirectTo(location, '/catalog' + location.pathname)} />
);

export const AppRoutes = () => (
  <Switch>
    <Route exact path="/" component={IndexPage} />

    <Route exact path="/catalog" component={Catalog} />
    <Route exact path="/catalog/watermeter" component={WaterIndex} />
    <Route exact path="/catalog/watermeter/s663" component={WaterS663} />
    <Route exact path="/catalog/watermeter/mec" component={WaterMec} />
    <Route exact path="/catalog/watermeter/voha" component={WaterVoha} />
    <Route exact path="/catalog/watermeter/para" component={WaterPara} />
    <Route exact path="/catalog/elecmeter" component={ElecIndex} />
    <Route exact path="/catalog/elecmeter/dds5168b" component={ElecDds5168b} />
    <Route exact path="/catalog/elecmeter/ddsu5168" component={ElecDdsu5168} />
    <Route exact path="/catalog/elecmeter/dds5168_4p" component={ElecDds5168_4p} />
    <Route exact path="/catalog/elecmeter/dtsd5168" component={ElecDtsd5168} />
    <Route exact path="/catalog/elecmeter/para" component={ElecPara} />
    <Route exact path="/catalog/heatmeter" component={HeatIndex} />
    <Route exact path="/catalog/heatmeter/r200" component={HeatR200} />
    <Route exact path="/catalog/heatmeter/h100" component={HeatH100} />
    <Route exact path="/catalog/gateway" component={GatewayIndex} />
    <Route exact path="/catalog/gateway/gw200" component={GatewayGw200} />
    <Route exact path="/catalog/gateway/joytcp" component={GatewayJoytcp} />
    <Route exact path="/catalog/gateway/cv151" component={GatewayCV151} />
    <Route exact path="/catalog/gateway/ct213" component={GatewayCT213} />

    <Route exact path="/solution/software" component={Software} />
    <Route exact path="/solution" component={Solution} />
    <Route path="/solution/water" component={SolutionWater} />
    <Route path="/solution/heat" component={SolutionHeat} />
    <Route path="/solution/elec" component={SolutionElec} />

    <Route exact path="/recruit" component={JobList} />
    <Route path="/recruit/details" component={JobDetail} />
    <Route path="/amrintroduce" component={AboutAmr} />
    <Route path="/about/amr" component={AboutMeterReading} />
    <Route path="/about/pay" component={AboutSettle} />
    <Route path="/about/elec2p" component={AboutDin2p} />
    <Route path="/privacy" component={PrivacyMendao} />
    <Route path="/amsprivacy" component={PrivacyAms} />
    <Route path="/amrprivacy" component={PrivacyAmr} />

    <Route path="/product/guide" component={ProductGuide} />
    <Route path="/product/detail" component={ProductDetail} />

    <Route exact path="/product/ct213" component={CT213} />
    <Route exact path="/product/cv151" component={CV151} />
    <Route exact path="/product/gw220" component={GW220} />
    <Route exact path="/product/list" component={ProductInteractionList} />
    <Route exact path="/product/ddsu5168" component={DDSU5168} />
    <Route exact path="/product/ddsu5168/wiring" component={DDSU5168Wiring} />
    <Route exact path="/product/ddsu5168-4p" component={DDSU5168FourPole} />
    <Route exact path="/product/ddsu5168-4p/wiring" component={DDSU5168FourPoleWiring} />
    <Route exact path="/product/dtsu5168" component={DTSU5168} />
    <Route exact path="/product/dtsu5168/wiring" component={DTSU5168Wiring} />
    <Route exact path="/product/ge400" component={GE400} />
    <Route exact path="/product/ge400/wiring" component={GE400Wiring} />
    <Route exact path="/product/joys550" component={JOYS550} />
    <Route exact path="/product/joys550/installation" component={JOYS550Installation} />
    <Route exact path="/product/faq" component={FaqPage} />
    <Route path="/manual" component={Details} />

    <Route
      exact
      path="/product"
      render={({ location }) => <Redirect to={redirectTo(location, '/catalog')} />}
    />
    <Route path="/watermeter" component={LegacyCatalogRedirect} />
    <Route path="/elecmeter" component={LegacyCatalogRedirect} />
    <Route path="/heatmeter" component={LegacyCatalogRedirect} />
    <Route path="/gateway" component={LegacyCatalogRedirect} />
  </Switch>
);

const App = () => (
  <Router>
    <AppRoutes />
  </Router>
);

export default App;
